export const searchBarPlaceholder = 'search by name or email...';
export const addButtonAlt = 'add';
export const pageTitle = 'Agents | Pineapple Labs';
